import { render, staticRenderFns } from "./LivingSpace.vue?vue&type=template&id=0a1e4262&scoped=true"
import script from "./LivingSpace.vue?vue&type=script&lang=js"
export * from "./LivingSpace.vue?vue&type=script&lang=js"
import style0 from "./LivingSpace.vue?vue&type=style&index=0&id=0a1e4262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e4262",
  null
  
)

export default component.exports